import Swiper from 'swiper/dist/js/swiper';
import breakpoints from '../helpers/breakpoints';

export default class {
  constructor($c) {
    const container = $c.find('.js-works-container');
    const prev = $c.find('.js-works-prev');
    const next = $c.find('.js-works-next');

    this.swiper = new Swiper(container, {
      navigation: { prevEl: prev, nextEl: next },
      loop: true,
      slidesPerView: 3,
      spaceBetween: 16,
      autoHeight: true,
      simulateTouch: false,
      breakpoints: {
        [breakpoints.mobile]: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    });
  }
  update() {
    this.swiper.update();
  }
}
